import React, { useState } from 'react';
import { Divider, Stack, Typography } from '@mui/material';

import { SetupOverlay } from 'features/procurementSetup/components/SetupOverlay';

import { useSettings } from '../api/getSettings';
import { useCompanySettings } from '../api/getCompanySettings';
import { useFrameworkAgreementSettings } from '../api/getFrameworkAgreementSettings';
import { useDPSSettings } from '../api/getDPSSettings';
import { useDirectSettings } from '../api/getDirectSettings';
import { numericSettingKeys } from '../validation';
import { EditSettingModal } from './EditSettingModal';
import { SettingListItem } from './SettingListItem';

const title = 'Fees';

export const SettingsOverlay = ({
  name,
  onClose,
  companyId,
  frameworkAgreementId,
  dpsId,
  directId,
}) => {
  const isOverrideScope = !!companyId || !!frameworkAgreementId || !!dpsId || !!directId;
  const { data: globalSettings, refetch: refetchGlobal } = useSettings({
    enabled: !isOverrideScope,
  });
  const { data: companySettings, refetch: refetchCompany } = useCompanySettings(companyId);
  const { data: faSettings, refetch: refetchFA } =
    useFrameworkAgreementSettings(frameworkAgreementId);
  const { data: dpsSettings, refetch: refetchDPS } = useDPSSettings(dpsId);
  const { data: directSettings, refetch: refetchDirect } = useDirectSettings(directId);
  const settings = companyId
    ? companySettings
    : frameworkAgreementId
    ? faSettings
    : dpsId
    ? dpsSettings
    : directId
    ? directSettings
    : globalSettings;
  const refetch = companyId
    ? refetchCompany
    : frameworkAgreementId
    ? refetchFA
    : dpsId
    ? refetchDPS
    : directId
    ? refetchDirect
    : refetchGlobal;
  const [activeSetting, setActiveSetting] = useState(null);

  const sections = settings.reduce((acc, setting) => {
    (acc[setting.section] = acc[setting.section] || []).push(setting);
    return acc;
  }, {});

  return (
    <SetupOverlay
      procurementName={name}
      crumbs={[{ label: title }]}
      isModalOpen={!!activeSetting}
      onClose={onClose}
    >
      {Object.entries(sections).map(([section, items]) => (
        <Stack key={section} mb={4} gap={1} width="100%">
          {section !== title && (
            <Typography variant="h6" fontWeight="bold">
              {section}
            </Typography>
          )}
          {items.map((setting) => {
            const isInherited = isOverrideScope && !setting.is_overridden;
            return (
              <SettingListItem
                key={setting.key}
                label={setting.label}
                value={isInherited ? setting.default_value : setting.value}
                unit={numericSettingKeys.includes(setting.key) ? 'SEK' : ''}
                isOverrideScope={isOverrideScope}
                isInherited={isInherited}
                onEdit={() => setActiveSetting(setting)}
              />
            );
          })}
          {section !== title && <Divider />}
        </Stack>
      ))}

      <EditSettingModal
        setting={activeSetting}
        open={!!activeSetting}
        handleClose={() => setActiveSetting(null)}
        refetch={refetch}
        companyId={companyId}
        frameworkAgreementId={frameworkAgreementId}
        dpsId={dpsId}
        directId={directId}
      />
    </SetupOverlay>
  );
};
